import { Flex, Text } from '@auviknetworks/iceberg-ui';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OptionCards } from './internal/OptionCards';

export const ChooseOptionStep = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Flex
            alignItems="center"
            data-testid="onboardingChooseOptionStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={['32px', '32px', '32px', 5]}
                color={theme.palette.onboarding.titleTextColor}
                fontWeight="600"
                textAlign="center"
            >
                {t('Onboarding.chooseOptionStep.title')}
            </Text>
            <Text
                fontSize={4}
                color={theme.palette.onboarding.titleTextColor}
                mt={3}
                textAlign="center"
            >
                {t('Onboarding.chooseOptionStep.subtitle')}
            </Text>
            <Flex flexDirection="column" mt="8%">
                <Text
                    color={theme.palette.text.primary}
                    fontSize={[3, 3, 3, 4]}
                    mb="4%"
                    dangerouslySetInnerHTML={{
                        __html: t('Onboarding.chooseOptionStep.intro')
                    }}
                />
            </Flex>
            <OptionCards />
        </Flex>
    );
};
